import React from "react";
import useProfile from "./useProfile";
import { EButton, ELabelView, EModal, EPageTitle, ETextInput } from "libs/ui";
import { FaRegEdit } from "react-icons/fa";
import EditableField from "./EditableField";
import ResetPassword from "./ResetPassword";

function Profile() {
  const {
    userProfile,
    mobile,
    setMobile,
    address1,
    setAddress1,
    address2,
    setAddress2,
    isEditing,
    handleEditing,
    isOpened,
    open,close,
  } = useProfile();
  const userName = `${userProfile?.firstName ?? ''} ${userProfile?.lastName ?? ''}`;

  return (
    <div>
      <EPageTitle
        title="Profile"
        subTitle={`Manage your profile ${userName ?? "User"}`}
      />
      <div className="flex justify-between items-center gap-2">
        <div>
          <ELabelView
            label="Email"
            value={userProfile?.emailId ?? ""}
            horizontal
          />
          {/* -----------Mobile Number---------- */}
          <div>
            <EditableField
              label="Mobile"
              value={mobile}
              type="tel"
              minLength={10}
              maxLength={12}
              placeholder="Enter new mobile number..."
              isEditing={isEditing.type === "mobile" && isEditing.isEditing}
              onEdit={() => handleEditing({ type: "mobile", isEditing: true })}
              onSave={() => {
                // Other Function
                handleEditing({ type: null, isEditing: false });
              }}
              onCancel={() => {
                // setMobile(userProfile?.mobile ?? "");
                handleEditing({ type: null, isEditing: false });
              }}
              onChange={setMobile}
            />
          </div>
          {/* ----------- Address 1 ----------------- */}
          <div>
            <EditableField
              label="Address 1"
              value={address1}
              type="text"
              minLength={5}
              maxLength={60}
              placeholder="Enter new address 1."
              isEditing={isEditing.type === "address 1" && isEditing.isEditing}
              onEdit={() => handleEditing({ type: "address 1", isEditing: true })}
              onSave={() => {
                handleEditing({ type: null, isEditing: false });
              }}
              onCancel={() => {
                handleEditing({ type: null, isEditing: false });
              }}
              onChange={setAddress1}
            />
          </div>
          {/* ---------- Address 2 ------------------ */}
          <div>
            <EditableField
              label="Address 2"
              value={address2}
              type="textarea"
              minLength={5}
              maxLength={60}
              placeholder="Enter new address 2."
              isEditing={isEditing.type === "address 2" && isEditing.isEditing}
              onEdit={() => handleEditing({ type: "address 2", isEditing: true })}
              onSave={() => {
                handleEditing({ type: null, isEditing: false });
              }}
              onCancel={() => {
                handleEditing({ type: null, isEditing: false });
              }}
              onChange={setAddress2}
            />
          </div>

        </div>
        <div className="bg-gray-400 h-[stretch] w-1"></div>
        <div>
          <EButton
            onClick={open}
          >
            Update Password
          </EButton>
        </div>
      </div>
      <div className="bg-gray-200 h-[3px] w-full my-4" />
      <div>
        <p className="font-bold mb-2">Others Details</p>
        <div className="mb-4">
          <div className="flex items-center gap-2 justify-between pt-2 px-2">
            <ELabelView label="Aadhar Number" value={"XXXX"} horizontal />
            <ELabelView label="GST Number" value={"XXXX"} horizontal />
            <ELabelView label="PAN Number" value={"XXXX"} horizontal />
          </div>
        </div>
        <div className="bg-gray-200 h-[3px] w-full my-4" />
        <div>
          <p className="font-bold mb-2">Credits Details</p>
          <div className="flex items-center gap-2 justify-between pt-2 px-2">
            <ELabelView
              label="Total Provided Credits"
              value={"XXXXX"}
              horizontal
            />
            <ELabelView label="Used Credits" value={"XXXXX"} horizontal />
            <ELabelView label="Remaning Credits" value={"XXXXX"} horizontal />
          </div>
        </div>
        <div className="bg-gray-200 h-[3px] w-full my-4" />
        <div>
          <p className="font-bold text-gary-700 mb-2">Company Details</p>
          <div className="mb-4">
            <div className="flex items-center gap-2 justify-between pt-2 px-2">
              <ELabelView
                label="Company Name"
                value={"XXXXXXXXXXXX"}
                horizontal
              />
              <ELabelView label="Address 1" value={"XXXXXX"} horizontal />
              <ELabelView label="Address 2" value={"XXXXXX"} horizontal />
            </div>
            <div className="flex items-center gap-2 justify-between py-2 px-2">
              <ELabelView label="State" value={"XXXXXXXXXXXXXXXX"} horizontal />
              <ELabelView label="Country" value={"XXXXX"} horizontal />
              <ELabelView label="Pin Code" value={"XXXXXX"} horizontal />
            </div>
          </div>
          <div className="bg-gray-200 h-[3px] w-full my-4" />
        </div>
      </div>

      {/* ----------- Password Reset Modal -------------*/}
      <EModal
        title="Reset Your Password"
        opened={isOpened}
        onClose={close}
      >
        <ResetPassword />
      </EModal>
    </div>
  );
}

export default Profile;
